module.exports = __webpack_public_path__ + "img/vip.06a44fe0.gif";